export const interestedByMapping = {
    interestedBy: 'specific.interestedBy'
};
